import * as React from 'react'
import {cn} from '@frontrow/console/src/lib/utils'
import {INPUT_BASE} from '@frontrow/console/src/lib/form-styles'

type Props = {
  id: string
  selectedDate?: Date | null
  onSelectDate: (selectedDate?: Date | null) => void
  /** Earliest date the browser will accept, so a range cannot be inverted. */
  min?: Date | null
}

function toInputValue(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

export function CalendarDatePicker({
  id,
  selectedDate,
  onSelectDate,
  min
}: Props): React.ReactElement {
  return (
    <div data-test="calendar-date-picker">
      <input
        id={id}
        type="date"
        // Width is left to the control's intrinsic size, and the height matches
        // SELECT_BASE so a picker and a select can sit in the same row.
        className={cn(INPUT_BASE, 'h-8 w-auto py-0')}
        value={selectedDate ? toInputValue(selectedDate) : ''}
        min={min ? toInputValue(min) : undefined}
        onChange={e => onSelectDate(e.target.value ? new Date(`${e.target.value}T00:00:00`) : null)}
      />
    </div>
  )
}
